import $ from 'jquery';

export class UiManagerService {
  public static scrollTo(hash: string) {
    window.location.hash = '';
    setTimeout(
      () =>
        $('html, body').animate(
          {
            scrollTop: ($(hash).offset()?.top || 0) + 20 - 20,
          },
          200,
          () => (window.location.hash = hash),
        ),
      200,
    );
  }
}
